import application from "stimulus_application";
import HeaderController from "./header_controller";
import "./header.css";

application.register("header", HeaderController);
